// extracted by mini-css-extract-plugin
export var chevron = "_1s-d";
export var disabled = "_1s-b";
export var error = "_1s-c";
export var hideBorder = "_1s-1";
export var icon = "_1s-e";
export var input = "_1s-0";
export var large = "_1s-f";
export var open = "_1s-9";
export var placeholder = "_1s-a";
export var regular = "_1s-5";
export var singleRowInput = "_1s-2";
export var singleSelectInput = "_1s-3 _1s-0";
export var small = "_1s-4";
export var spinnerContainer = "_1s-i";
export var tag = "_1s-7";
export var tagsContainer = "_1s-8";
export var tagsInput = "_1s-6 _1s-0";
export var xSmall = "_1s-g";
export var xxSmall = "_1s-h";